import { validateField, clearFields, setFieldOptions } from './helpers/form'
import {
	SET_CLIENTACCOUNT_SEARCH_DROPDOWN_OPTIONS_CLIENTS,
	SET_CLIENTACCOUNT_SEARCH_DROPDOWN_OPTIONS_COUTRIES,
	CLEAR_CLIENTACCOUNT_SEARCH_FIELDS,
	VALIDATE_CLIENTACCOUNT_SEARCH_FIELD
} from '../../../actions/pages/clientaccount-page'

export function clientAccountSearch(
	state = {
		valid: false,
		fields: [
			{
				name: 'Client',
				value: '',
				errors: [],
				rules: {
					title: 'Client'
				},
				placeholder: 'All clients',
				options: []
			},
			{
				name: 'Country',
				value: '',
				errors: [],
				rules: {
					title: 'Country'
				},
				placeholder: 'All countries',
				options: []
			}
		]
	},
	action
) {
	switch (action.type) {
		case SET_CLIENTACCOUNT_SEARCH_DROPDOWN_OPTIONS_CLIENTS:
			return setFieldOptions(state, 'Client', action.productionContentOwners);
		case SET_CLIENTACCOUNT_SEARCH_DROPDOWN_OPTIONS_COUTRIES:
			return setFieldOptions(state, 'Country', action.countries);
		case VALIDATE_CLIENTACCOUNT_SEARCH_FIELD:
			return validateField(state, action);
		case CLEAR_CLIENTACCOUNT_SEARCH_FIELDS:
			return clearFields(state);
		default:
			return state
	}
}